import logoUser from '../../../assets/images/users/1.jpg'
import logoIcon from '../../../assets/images/logo-icon-fastcapital1.png'
import logoLightIcon from '../../../assets/images/logo-icon-fastcapital1.png'
import logoText from '../../../assets/images/logo-texto-fastcapital.png'
import logoLightText from '../../../assets/images/logo-texto-fastcapital.png'
import { AuthContext } from "../AuthProvider";
import { useNavigate } from 'react-router-dom'
import {useContext, useEffect, useState} from 'react'
import { Functions } from '../../../helpers/Functions'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CONFIGURACIONES from '../../../util/constants'
import {useZonaAgencia} from "../../context/ZonaAgenciaContext.jsx";

const TopBar = ({themeSettings, getDataUser, getDataZonasAgencias}) => {
    const {zona, setZona, agencia, setAgencia} = useZonaAgencia();

    const redirect = useNavigate();
    const { signOut: signOutContext } = useContext(AuthContext);
    const [renderAgencias, setRenderAgencias] = useState(CONFIGURACIONES.INIT.ARRAY);

    const signOut = () => {
        Functions().signOut();
        redirect('/');
    };

    useEffect(() => {
        let zonaId = getDataZonasAgencias.zonas[0].id;
        let listAgencias = getDataZonasAgencias.agencias.filter((el) => el.zona_id === zonaId)
        setRenderAgencias(listAgencias);
        setZona(zonaId);
        if (listAgencias.length > 0) { setAgencia(listAgencias[0].id); }
    }, []);
    return (
        <header className="topbar" data-navbarbg={themeSettings.navbarBg}>
            <nav className="navbar top-navbar navbar-expand-md navbar-dark">
                <div className="navbar-header" data-logobg={themeSettings.logoBg}>
                    <a className="nav-toggler waves-effect waves-light d-block d-md-none" id="nav-toggler" href="#"><i className="ti-menu ti-close"></i></a>
                    <a className="navbar-brand" href="/" target="_blank">
                        <b className="logo-icon mr-0">
                            <img src={logoIcon} alt="homepage" className="dark-logo" />
                            <img src={logoLightIcon} alt="homepage" className="light-logo" />
                        </b>
                        <span className="logo-text">
                            <img src={logoText} alt="homepage" className="dark-logo" />
                            <img src={logoLightText} className="light-logo" alt="homepage" />
                        </span>
                    </a>
                    <a className="topbartoggler d-block d-md-none waves-effect waves-light" href="#" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><i className="ti-more"></i></a>
                </div>
                <div className="navbar-collapse collapse" id="navbarSupportedContent" data-navbarbg={themeSettings.navbarBg}>
                    <ul className="navbar-nav float-left mr-auto">
                        <li className="nav-item d-none d-md-block"><a className="nav-link sidebartoggler waves-effect waves-light" href="#" data-sidebartype="mini-sidebar"><i className="mdi mdi-menu font-24"></i></a></li>
                        {/* <li className="nav-item dropdown mega-dropdown"><a className="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span className="d-none d-md-block">Mega <i className="fa fa-angle-down"></i></span>
                                <span className="d-block d-md-none"><i className="mdi mdi-dialpad font-24"></i></span>
                            </a>
                            <div className="dropdown-menu animated bounceInDown">
                                <div className="mega-dropdown-menu row">
                                    <div className="col-lg-3 col-xlg-2 mb-4">
                                        <h4 className="mb-3">CAROUSEL</h4>
                                         <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                                            <div className="carousel-inner" role="listbox">
                                                <div className="carousel-item active">
                                                    <div className="container p-0"> <img className="d-block img-fluid" src="../../../assets/images/big/img1.jpg" alt="First slide" /></div>
                                                </div>
                                                <div className="carousel-item">
                                                    <div className="container p-0"><img className="d-block img-fluid" src="../../../assets/images/big/img2.jpg" alt="Second slide" /></div>
                                                </div>
                                                <div className="carousel-item">
                                                    <div className="container p-0"><img className="d-block img-fluid" src="../../../assets/images/big/img3.jpg" alt="Third slide" /></div>
                                                </div>
                                            </div>
                                            <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev"> <span className="carousel-control-prev-icon" aria-hidden="true"></span> <span className="sr-only">Previous</span> </a>
                                            <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next"> <span className="carousel-control-next-icon" aria-hidden="true"></span> <span className="sr-only">Next</span> </a>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-4">
                                        <h4 className="mb-3">ACCORDION</h4>
                                        <div id="accordion">
                                            <div className="card mb-1">
                                                <div className="card-header" id="headingOne">
                                                    <h5 className="mb-0">
                                                <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Collapsible Group Item #1
                                                </button>
                                                </h5>
                                                </div>
                                                <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                                    <div className="card-body">
                                                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-1">
                                                <div className="card-header" id="headingTwo">
                                                    <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    Collapsible Group Item #2
                                                </button>
                                                </h5>
                                                </div>
                                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                                    <div className="card-body">
                                                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card mb-1">
                                                <div className="card-header" id="headingThree">
                                                    <h5 className="mb-0">
                                                <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                    Collapsible Group Item #3
                                                </button>
                                                </h5>
                                                </div>
                                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                                    <div className="card-body">
                                                        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3  mb-4">
                                        <h4 className="mb-3">CONTACT US</h4>
                                        <form>
                                            <div className="form-group">
                                                <input type="text" className="form-control" id="exampleInputname1" placeholder="Enter Name" /> </div>
                                            <div className="form-group">
                                                <input type="email" className="form-control" placeholder="Enter email" /> </div>
                                            <div className="form-group">
                                                <textarea className="form-control" id="exampleTextarea" rows="3" placeholder="Message"></textarea>
                                            </div>
                                            <button type="submit" className="btn btn-info">Submit</button>
                                        </form>
                                    </div>
                                    <div className="col-lg-3 col-xlg-4 mb-4">
                                        <h4 className="mb-3">List style</h4>
                                        <ul className="list-style-none">
                                            <li><a href="#"><i className="fa fa-check text-success"></i> You can give link</a></li>
                                            <li><a href="#"><i className="fa fa-check text-success"></i> Give link</a></li>
                                            <li><a href="#"><i className="fa fa-check text-success"></i> Another Give link</a></li>
                                            <li><a href="#"><i className="fa fa-check text-success"></i> Forth link</a></li>
                                            <li><a href="#"><i className="fa fa-check text-success"></i> Another fifth link</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li> */}
                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="d-none d-md-block">Create New <i className="fa fa-angle-down"></i></span>
                                <span className="d-block d-md-none"><i className="fa fa-plus"></i></span>   
                            </a>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <a className="dropdown-item" href="#">Action</a>
                                <a className="dropdown-item" href="#">Another action</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item" href="#">Something else here</a>
                            </div>
                        </li> */}
                           {/* <li className="nav-item search-box"> <a className="nav-link waves-effect waves-dark" href="#"><i className="ti-search"></i></a>
                            <form className="app-search position-absolute">
                                <input type="text" className="form-control" placeholder="Search &amp; enter" /> <a className="srh-btn"><i className="ti-close"></i></a>
                            </form>
                        </li> */}
                    </ul>
                    <ul className="navbar-nav float-right">

                        {/* Selects Zona y Agencia */}
                        {/* <div className="d-flex align-items-center ms-auto me-4">
                            <div className="me-3">
                                <label htmlFor="zona" className="form-label text-white mb-0 small">Zona</label>
                                <select id="zona" className="form-control form-control-sm bg-light text-dark border-0 shadow-sm"
                                    style={{ minWidth: "130px" }} >
                                    <option value="">Seleccione</option>
                                    <option value="norte">Norte</option>
                                    <option value="sur">Sur</option>
                                    <option value="este">Este</option>
                                    <option value="oeste">Oeste</option>
                                </select>
                            </div>

                            <div className="ml-2">
                                <label htmlFor="agencia" className="form-label text-white mb-0 small">Agencia</label>
                                <select id="agencia" className="form-control form-control-sm bg-light text-dark border-0 shadow-sm"
                                    style={{ minWidth: "150px" }} >
                                    <option value="">Seleccione</option>
                                    <option value="principal">Principal</option>
                                    <option value="secundaria">Secundaria</option>
                                    <option value="sucursal">Sucursal</option>
                                </select>
                            </div>
                        </div> */}

                        {/* Selects Zona y Agencia - En una sola línea */}
                        {/* <div className="d-flex align-items-center ml-auto mr-4">
                            <div className="d-flex align-items-center mr-3">
                                <label htmlFor="zona" className="text-white small mb-0 mr-2">Zona:</label>
                                <select id="zona" className="form-control form-control-sm bg-light text-dark border-0" style={{ width: "130px" }}>
                                    <option value="">Seleccione</option>
                                    <option value="norte">Norte</option>
                                    <option value="sur">Sur</option>
                                    <option value="este">Este</option>
                                    <option value="oeste">Oeste</option>
                                </select>
                            </div>

                            <div className="d-flex align-items-center">
                                <label htmlFor="agencia" className="text-white small mb-0 mr-2">Agencia:</label>
                                <select id="agencia" className="form-control form-control-sm bg-light text-dark border-0" style={{ width: "150px" }} >
                                    <option value="">Seleccione</option>
                                    <option value="principal">Principal</option>
                                    <option value="secundaria">Secundaria</option>
                                    <option value="sucursal">Sucursal</option>
                                </select>
                            </div>
                        </div> */}

                        {/* Selects Zona y Agencia - Responsive */}
                        <div className="d-none d-lg-flex align-items-center ml-auto mr-3">
                        {/* Zona */}
                        <div className="d-flex align-items-center mr-3 mb-2 mb-lg-0">
                            <label htmlFor="zona" className="text-white small mb-0 mr-2">Zona:</label>
                            <select
                                id="zona"
                                className="form-control form-control-sm bg-light text-dark border-0"
                                style={{ width: "130px", minWidth: "110px" }}
                                onChange={(e) => {
                                    setZona(e.target.value)
                                    setRenderAgencias(getDataZonasAgencias.agencias.filter((el) => el.zona_id === e.target.value));
                                }}
                            >
                                { getDataZonasAgencias.zonas.map((el, index) => (
                                    <option key={`zona_${index}`} value={el.id}>{el.nombre}</option>
                                ))}
                            </select>
                        </div>

                        {/* Agencia */}
                        <div className="d-flex align-items-center mb-2 mb-lg-0">
                            <label htmlFor="agencia" className="text-white small mb-0 mr-2">Agencia:</label>
                            <select
                                id="agencia"
                                className="form-control form-control-sm bg-light text-dark border-0"
                                style={{ width: "150px", minWidth: "120px" }}
                                onChange={(e) => setAgencia(e.target.value)}
                            >
                                { renderAgencias.map((el, index) => (
                                    <option value={el.id} key={`agencia_${index}`}>{el.nombre}</option>
                                ))}
                            </select>
                        </div>
                        </div>

                        {/* <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="flag-icon flag-icon-us"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-right  animated bounceInDown" aria-labelledby="navbarDropdown2">
                                <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-us"></i> English</a>
                                <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-fr"></i> French</a>
                                <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-es"></i> Spanish</a>
                                <a className="dropdown-item" href="#"><i className="flag-icon flag-icon-de"></i> German</a>
                            </div>
                        </li> */}
                        <li className="nav-item d-lg-none">
                            <a className="nav-link waves-effect waves-dark" href="#" aria-expanded="false">
                                <i className="mdi mdi-map font-24"></i>
                            </a>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i className="mdi mdi-bell font-24"></i>
                                
                            </a>
                            <div className="dropdown-menu dropdown-menu-right mailbox animated bounceInDown">
                                <span className="with-arrow"><span className="bg-primary"></span></span>
                                <ul className="list-style-none">
                                    <li>
                                        <div className="drop-title bg-primary text-white">
                                            <h4 className="mb-0 mt-1">4 New</h4>
                                            <span className="font-light">Notifications</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="message-center notifications">
                                            <a href="#" className="message-item">
                                                <span className="btn btn-danger btn-circle"><i className="fa fa-link"></i></span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Luanch Admin</h5> <span className="mail-desc">Just see the my new admin!</span> <span className="time">9:30 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="btn btn-success btn-circle"><i className="ti-calendar"></i></span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Event today</h5> <span className="mail-desc">Just a reminder that you have event</span> <span className="time">9:10 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="btn btn-info btn-circle"><i className="ti-settings"></i></span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Settings</h5> <span className="mail-desc">You can customize this template as you want</span> <span className="time">9:08 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="btn btn-primary btn-circle"><i className="ti-user"></i></span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Pavan kumar</h5> <span className="mail-desc">Just see the my admin!</span> <span className="time">9:02 AM</span> </div>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <a className="nav-link text-center mb-1 text-dark" href="#;"> <strong>Check all notifications</strong> <i className="fa fa-angle-right"></i> </a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle waves-effect waves-dark" href="" id="2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i className="font-24 mdi mdi-comment-processing"></i>
                                
                            </a>
                            <div className="dropdown-menu dropdown-menu-right mailbox animated bounceInDown" aria-labelledby="2">
                                <span className="with-arrow"><span className="bg-danger"></span></span>
                                <ul className="list-style-none">
                                    <li>
                                        <div className="drop-title text-white bg-danger">
                                            <h4 className="mb-0 mt-1">5 New</h4>
                                            <span className="font-light">Messages</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="message-center message-body">
                                            <a href="#" className="message-item">
                                                <span className="user-img"> <img src={logoUser} alt="user" className="rounded-circle" /> <span className="profile-status online pull-right"></span> </span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Pavan kumar</h5> <span className="mail-desc">Just see the my admin!</span> <span className="time">9:30 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="user-img"> <img src="../../../assets/images/users/2.jpg" alt="user" className="rounded-circle" /> <span className="profile-status busy pull-right"></span> </span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Sonu Nigam</h5> <span className="mail-desc">I've sung a song! See you at</span> <span className="time">9:10 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="user-img"> <img src="../../../assets/images/users/3.jpg" alt="user" className="rounded-circle" /> <span className="profile-status away pull-right"></span> </span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Arijit Sinh</h5> <span className="mail-desc">I am a singer!</span> <span className="time">9:08 AM</span> </div>
                                            </a>
                                            <a href="#" className="message-item">
                                                <span className="user-img"> <img src="../../../assets/images/users/4.jpg" alt="user" className="rounded-circle" /> <span className="profile-status offline pull-right"></span> </span>
                                                <div className="mail-contnet">
                                                    <h5 className="message-title">Pavan kumar</h5> <span className="mail-desc">Just see the my admin!</span> <span className="time">9:02 AM</span> </div>
                                            </a>
                                        </div>
                                    </li>
                                    <li>
                                        <a className="nav-link text-center link text-dark" href="#;"> <b>See all e-Mails</b> <i className="fa fa-angle-right"></i> </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle text-muted waves-effect waves-dark pro-pic" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <img src={logoUser} alt="user" className="rounded-circle" width="31" />
                            </a>
                            <div className="dropdown-menu dropdown-menu-right user-dd animated flipInY">
                                <span className="with-arrow"><span className="bg-primary"></span></span>
                                <div className="d-flex no-block align-items-center p-15 bg-primary text-white mb-2">
                                    <div className=""><img src={logoUser} alt="user" className="img-circle" width="60" /></div>
                                    <div className="ml-2">
                                        <h4 className="mb-0">{getDataUser.user}</h4>
                                        <p className=" mb-0">{getDataUser.area}</p>
                                        <p className=" mb-0">{getDataUser.cargo}</p>
                                    </div>
                                </div>
                                {/* <a className="dropdown-item" href="#"><i className="ti-user mr-1 ml-1"></i> My Profile</a>
                                <a className="dropdown-item" href="#"><i className="ti-wallet mr-1 ml-1"></i> My Balance</a>
                                <a className="dropdown-item" href="#"><i className="ti-email mr-1 ml-1"></i> Inbox</a>
                                <div className="dropdown-divider"></div> */}
                                <a className="dropdown-item" href="#"><i className="ti-settings mr-1 ml-1"></i> Configuración de Cuenta</a>
                                <div className="dropdown-divider"></div>
                                <a className="dropdown-item" href="#" onClick={() => Functions().signOut(redirect, toast)}><i className="fa fa-power-off mr-1 ml-1"></i> Cerrar Sesión</a>
                                {/* <div className="dropdown-divider"></div>
                                <div className="pl-4 p-10"><a className="btn btn-sm btn-success text-white btn-rounded">Configuraciones</a></div> */}
                            </div>
                        </li>
                      </ul>
                </div>
            </nav>
            
            {/* <ToastContainer autoClose={CONFIGURACIONES.INIT.TOAST_CLOSE} /> */}
        </header>
    )
}

export default TopBar;